import { render, staticRenderFns } from "./FederalList.vue?vue&type=template&id=4c054cd4&scoped=true&"
import script from "./FederalList.vue?vue&type=script&lang=js&"
export * from "./FederalList.vue?vue&type=script&lang=js&"
import style0 from "./FederalList.vue?vue&type=style&index=0&id=4c054cd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c054cd4",
  null
  
)

export default component.exports